import { Box } from '@mui/material';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { CheckboxRadioItem } from '@work4all/components/lib/input/checkbox-radio-item';

import { Currency } from '@work4all/models/lib/Classes/Currency.entity';
import { Entities } from '@work4all/models/lib/Enums/Entities.enum';

import { EditTableColumns } from '../../../containers/mask-overlays/mask-overlay/views/erp/components/tab-panels/positions/components/edit-table/types';
import { settings, useSetting } from '../../../settings';
import { EditableEntityTable } from '../editable-entity-table/EditableEntityTable';

const CURRENCY_DATA: Currency = {
  id: null,
  name: null,
};

const newEntryMandatoryFields: (keyof Currency)[] = ['name'];

export const CurrencyTable = () => {
  const { t } = useTranslation();

  const reserveCurrencyId = useSetting(settings.reserveCurrencyId());

  const cols = useMemo<EditTableColumns<Currency>[]>(
    () => [
      {
        Header: t('COMMON.NAME'),
        accessor: 'name',
        width: 150,
        type: 'text',
        resizable: false,
      },
      {
        Header: t('COMMON.RESERVE_CURRENCY'),
        accessor: 'id',
        width: 150,
        type: 'text',
        editable: false,
        Cell: (e) => {
          const id = e.row.original.id;

          if (id === -1) {
            return null;
          }

          return (
            <Box margin="-0.75rem 0">
              <CheckboxRadioItem
                label=""
                control="radio"
                checked={id === reserveCurrencyId.value}
                onChange={() => reserveCurrencyId.set(id)}
              />
            </Box>
          );
        },
      },
    ],
    [reserveCurrencyId, t]
  );

  return (
    <EditableEntityTable<Currency>
      columns={cols}
      dataFields={CURRENCY_DATA}
      entity={Entities.currency}
      idType="number"
      sortByField="name"
      newEntryMandatoryFields={newEntryMandatoryFields}
      enableDelete={false}
      dataProviderProps={{
        completeDataResponse: true,
      }}
    />
  );
};
